import {useCallback, useMemo} from "react";
import type {MaybeNil} from "app/utils/types";
import type {AsyncOrSync} from "ts-essentials";
import {isNil} from "app/utils/stdlib";
import {IdComboBox, type IdComboBoxProps} from "app/employee/controlCard/IdComboBox";

export interface IdSingleComboBoxProps<Option, Value> extends Omit<
  IdComboBoxProps<Option, Value>,
  "value" | "onSelect" | "multiselect"
> {
  value?: MaybeNil<Value>;
  onSelect?: (option: MaybeNil<Option>) => AsyncOrSync<void>;
}

export const IdSingleComboBox = <Option, Value>({value, onSelect, ...rest}: IdSingleComboBoxProps<Option, Value>) => {
  const valueArr = useMemo(() => (!isNil(value) ? [value] : null), [value]);
  const handleSelect = useCallback(
    (option: MaybeNil<Option[]>) => {
      if (!isNil(option) && option.length > 0) {
        onSelect?.(option[0]);
      } else {
        onSelect?.(null);
      }
    },
    [onSelect]
  );

  return <IdComboBox {...rest} multiselect={false} onSelect={handleSelect} value={valueArr} />;
};
